import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@modules/shared/services/api.service';

@Injectable()
export class VisaService extends ApiService {
    constructor(private _http: HttpClient, protected injector: Injector) {
        super(injector);
    }

    getSessionToken(data: any) {
        return this.post('payments/session', data);
    }

    getVisaResponseValue() {
        return this._http.get('/assets/json/visa_response.json');
    }

    validateTransaction(data: any) {
        // return this._http.post(`http://localhost:3300/v1/payments/authorize`, data);
        return this.post(`payments/authorize`, data);
    }
}
